import axiosHelper from "../../../../axiosHelper";
import {
  APIUSEROLD,
  API_FAILURE,
  GET_EXCEPTIONAL_APPROVAL,
} from "../../../../config/constants";
import { apiErrors } from "../../../../helper";
import Toaster from "../../../common/Toaster";

export function fetchExceptionalApprovalList(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getExceptionalApprovalList}`,
      {
        params: {
          EmployeeId: filter?.EmployeeId,
          page: filter.current_page,
          pageSize: filter.per_page,
          SearchText: filter?.sortField?.supplierName,
          SortBy: filter?.sortField,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate,
          RequestToDate: filter.requestFromDate,
        }, // Assuming filter contains necessary query33 parameters
      }
    );
    request
      .then((response) => {
        // if (response?.data || response.status === 204) {
        if (response?.data?.IsSuccessful) {
          dispatch({
            type: GET_EXCEPTIONAL_APPROVAL,
            payload: {
              // data: response.status === 204 ? [] : response?.data?.Result,
              data: response?.data?.Data.length > 0 ? response?.data?.Data : [],
              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
      }else{
        callback(null, error);
      }
        
        // apiErrors(error);
      });
  };
}

export function exceptionApprovalAcceptReject(data, callback) {
  return (dispatch) => {
    const request = axiosHelper.post(
      APIUSEROLD.exceptionApprovalAcceptReject,
      data
    );
    request
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        Toaster.error(error?.response?.data?.ErrorMessage);
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
      }else{
        callback(error); // Pass the error to the callback
        throw error; // Throw the error to propagate to the caller's catch block
      }
        
      });
  };
}
